import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardGuru } from 'app/KinerjaPage/components/PageGuardGuru'
import { SepakatiPerencanaan } from 'app/KinerjaGuruPage/pages/perencanaan/SepakatiPerencanaan'

import type { SepakatiPerencanaanProps } from 'app/KinerjaGuruPage/pages/perencanaan/SepakatiPerencanaan'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { GetServerSidePropsResult, NextPageContext } from 'next'

type PageProps = SepakatiPerencanaanProps
export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ): Promise<GetServerSidePropsResult<PageProps>> => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPerencanaanEnabled =
      toggle?.['kinerja-perencanaan-enabled'] || false
    const isUlangiPerencanaanEnabled =
      toggle?.['kinerja-delete-perencanaan-enabled']
    const isKinerjaPerencanaan2026Enabled =
      toggle?.['kinerja-perencanaan-2026-enabled'] || false

    if (
      !isKinerjaEnabled ||
      !isKinerjaPerencanaanEnabled ||
      !isKinerjaPerencanaan2026Enabled
    ) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }

    return {
      props: {
        isUlangiPerencanaanEnabled,
      },
    }
  },
})

export default function Page({ isUlangiPerencanaanEnabled }: PageProps) {
  return (
    <PageGuardGuru>
      <SepakatiPerencanaan
        isUlangiPerencanaanEnabled={isUlangiPerencanaanEnabled}
      />
    </PageGuardGuru>
  )
}

Page.Layout = KinerjaLayout
